/**
 * Deutscher Textkatalog für das Feature „Bücher & Regeln“ / Kampagne
 * (`@gamecodex/world-ui` → `features/books`).
 *
 * Die Schlüssel spiegeln die `t('books.*')`-Aufrufe in den React-Komponenten des
 * Features wider. Die Werte sind die deutschen Übersetzungen der während des
 * i18n-Durchlaufs extrahierten Original-Strings.
 */
export const booksDe = {
  // BackerDownloadModal.tsx
  'books.backerModal.title': 'Sichere dir dein Unterstützer-PDF',
  'books.backerModal.sendLinkError': 'Wir konnten deinen Anmeldelink gerade nicht senden. Versuche es gleich noch einmal.',
  'books.backerModal.checkInboxPrefix': 'Sieh in deinem Postfach nach unter',
  'books.backerModal.checkInboxSuffix':
    'Wenn du mit dieser E-Mail unterstützt hast, ist ein Anmeldelink unterwegs — klick ihn an, um dein Exemplar zu sichern.',
  'books.backerModal.linkAutoSignIn': 'Der Link öffnet sich auf dieser Seite und meldet dich automatisch an. Kein Passwort nötig.',
  'books.backerModal.signInIntro':
    'Gib die E-Mail ein, mit der du unterstützt hast. Wir senden dir einen Ein-Klick-Anmeldelink und bereiten dann dein persönliches Exemplar vor.',
  'books.backerModal.pledgeEmailLabel': 'E-Mail des Unterstützer-Kontos',
  'books.backerModal.emailLinkCta': 'Schick mir einen Anmeldelink',
  'books.backerModal.prepareTimeout':
    'Dein Exemplar braucht länger als erwartet zur Vorbereitung. Bitte versuche es in ein paar Minuten erneut.',
  'books.backerModal.notEntitled': 'Du bist angemeldet, aber dieses Buch ist nicht in deinem Beitrag enthalten.',
  'books.backerModal.notClaimable': 'Dieses Buch wird nicht als Unterstützer-Download angeboten.',
  'books.backerModal.prepareError': 'Wir konnten deinen Download gerade nicht vorbereiten. Versuche es gleich noch einmal.',
  'books.backerModal.signedInAs': 'Angemeldet als',
  'books.backerModal.signOut': 'Abmelden',
  'books.backerModal.verified': 'Verifiziert',
  'books.backerModal.welcomeBack': ' — willkommen zurück,',
  'books.backerModal.backerNumber': '(Unterstützer #{number})',
  'books.backerModal.copyReady':
    'Dein persönliches Exemplar ist bereit. Dieser Link ist persönlich und läuft bald ab — bitte teile ihn nicht.',
  'books.backerModal.downloadPdf': 'Lade dein PDF herunter',
  'books.backerModal.dtrpgEmailLabel': 'E-Mail des DriveThruRPG-Kontos',
  'books.backerModal.optional': '(optional)',
  'books.backerModal.dtrpgWarn':
    'Gib dies an, um den Kauf auch in deine DriveThruRPG-Bibliothek zu spiegeln. Lass es weg, und dein Exemplar bleibt hier dennoch herunterladbar.',
  'books.backerModal.preparingCopy': 'Dein Exemplar wird vorbereitet…',
  'books.backerModal.prepareDownload': 'Vorbereiten & Herunterladen',

  // BackerVerifyPage.tsx
  'books.backerVerify.missingToken': 'Diesem Anmeldelink fehlt sein Token. Fordere auf der Buchseite einen neuen Link an.',
  'books.backerVerify.invalidToken':
    'Dieser Anmeldelink ist ungültig oder abgelaufen. Fordere auf der Buchseite einen neuen an.',
  'books.backerVerify.seoTitle': 'Unterstützer-Anmeldung',
  'books.backerVerify.seoDescription': 'Dein Grymwyrd-Unterstützer-Anmeldelink wird verifiziert.',
  'books.backerVerify.confirming': 'Deine Unterstützer-Anmeldung wird bestätigt…',
  'books.backerVerify.signedInHeading': 'Du bist angemeldet',
  'books.backerVerify.signedInAs': 'Angemeldet als',
  'books.backerVerify.headBackPrefix': 'Kehre zum Buch zurück und klicke auf',
  'books.backerVerify.downloadWord': 'Herunterladen',
  'books.backerVerify.headBackSuffix': 'um dein Exemplar zu sichern.',
  'books.backerVerify.backToBook': 'Zurück zu deinem Buch',
  'books.backerVerify.browseAthenaeum': 'Im Athenäum stöbern',
  'books.backerVerify.problemHeading': 'Problem mit dem Anmeldelink',

  // BookCard.tsx
  'books.card.viewAria': '{title} ansehen',
  'books.card.coverAlt': 'Cover von {title}',
  'books.card.owned': 'Im Besitz',

  // BookCover.tsx
  'books.cover.coverAlt': 'Cover von {title}',

  // BookStorePage.tsx
  'books.store.seoTitle': 'Bücher & Regeln',
  'books.store.seoDescription':
    'Folianten des ewigen Zwielichts — Kernregelwerke, das illustrierte SRD und grimmig-düstere Abenteuer. Kaufe sie, um Module freizuschalten und Münzen zu verdienen.',
  'books.store.eyebrow': 'Das Athenäum',
  'books.store.heading': 'Bücher & Regeln',
  'books.store.intro':
    'Erwirb die Folianten, die die Welt zusammenhalten. Jeder Kauf schaltet spielbare Module in deinen Kampagnen frei und belohnt dich mit Münzen für die Wirtschaft der Spielwelt.',
  'books.store.filterAria': 'Bücher nach Typ filtern',
  'books.store.filterAll': 'Alle',
  'books.store.loading': 'Das Archiv wird entsiegelt…',
  'books.store.empty': 'Noch passt kein Foliant in diese Kategorie. Die Schreiber sind noch am Werk.',

  // BuyButton.tsx
  'books.buy.checkoutUnavailable': 'Der Bezahlvorgang ist noch nicht verfügbar. Bitte versuche es bald erneut.',
  'books.buy.signInToClaim': 'Melde dich an, um diesen Folianten zu sichern.',
  'books.buy.ledgerSealed': 'Das Hauptbuch des Händlers ist vorerst versiegelt — der Bezahlvorgang kommt bald.',
  'books.buy.inLibrary': 'In deiner Bibliothek',
  'books.buy.openingVault': 'Das Gewölbe wird geöffnet…',
  'books.buy.claimFree': 'Kostenlos sichern',
  'books.buy.buyPrice': 'Kaufen — {price}',
  'books.buy.unlockPrefix': 'Kaufen → Module freischalten +',
  'books.buy.coinsSuffix': '{coins} Münzen',

  // BookDetailPage.tsx
  'books.detail.loading': 'Die Seiten werden umgeblättert…',
  'books.detail.backToAthenaeum': 'Zurück zum Athenäum',
  'books.detail.unlockOwned': 'Du besitzt diesen Folianten — seine Grymwyrd-Überlieferung ist in der gesamten Enzyklopädie freigeschaltet.',
  'books.detail.unlockClaim': 'Sichere dir diesen Folianten, um seine Grymwyrd-Überlieferung in der gesamten Enzyklopädie freizuschalten.',
  'books.detail.returnTo': 'Zurück zu {label}',
  'books.detail.backerCta': 'Unterstützer? Lade dein PDF herunter',
  'books.detail.coinsEarned': 'Du hast mit diesem Kauf {coins} Münzen verdient.',
  'books.detail.coinsGranted': 'Der Kauf bringt {coins} Münzen in deinen Hort.',
  'books.detail.byAuthor': 'Von {author}',
  'books.detail.statPrice': 'Preis',
  'books.detail.statPages': 'Seiten (letzte Erzeugung)',
  'books.detail.statWords': 'Wörter (letzte Erzeugung)',
  'books.detail.ofThisTome': 'Über diesen Folianten',
  'books.detail.noDescription': 'Für diesen Band wurde noch keine Beschreibung verfasst.',
  'books.detail.previewHeading': 'Vorschau',
  'books.detail.previewBlurb': 'Wirf einen Blick auf eine Leseprobe dieses Folianten, bevor du ihn dir sicherst.',
  'books.detail.readPreview': 'Leseprobe lesen',
  'books.detail.tocHeading': 'Inhaltsverzeichnis',
  'books.detail.tocEmpty': 'Der Inhalt dieses Folianten wurde noch nicht katalogisiert.',
  'books.detail.pageAbbrev': 'S. {page}',
  'books.detail.unlockedHeading': 'Freigeschaltete Enzyklopädie-Einträge',
  'books.detail.unlockedOwnedNote': 'Jetzt Teil deiner lebendigen Enzyklopädie:',
  'books.detail.unlockedLockedNote':
    'Kaufe diesen Folianten, um seine Kreaturen, Zauber und Geheimnisse in deine Enzyklopädie einzuschreiben — und sichere dir',
  'books.detail.coinsAmount': '{coins} Münzen',
  'books.detail.attributionsHeading': 'Quellenangaben & Lizenzierung',
  'books.detail.attributionSource': 'Quelle',
  'books.detail.attributionLink': 'Link',

  // CampaignLandingPage.tsx
  'books.campaign.liveCampaign': 'Laufende Kampagne',
  'books.campaign.backThisProject': 'Dieses Projekt unterstützen',
  'books.campaign.viewStretchGoals': 'Stretch Goals ansehen',
  'books.campaign.pledged': 'Zugesagt',
  'books.campaign.backers': 'Unterstützer',
  'books.campaign.pitchHeading': 'Das Konzept',
  'books.campaign.backerUnlockedHeading': 'Von Unterstützern freigeschaltete Einträge',
  'books.campaign.backerUnlockedBlurb':
    'Unterstützer erhalten frühen Zugang zu Inhalten, die direkt in die lebendige Enzyklopädie fließen. Hier ein Vorgeschmack auf das, was bereits Kanon ist:',
  'books.campaign.previewsEmpty': 'Neuer Kanon wird gerade eingeschrieben — schau wieder vorbei, sobald Ziele freigeschaltet werden.',
  'books.campaign.choosePledge': 'Wähle deinen Beitrag',
  'books.campaign.mostBacked': 'Am meisten unterstützt',
  'books.campaign.pledgeAmount': '{amount} zusagen',
  'books.campaign.pledgeFooter':
    'Beiträge werden beim Bezahlvorgang sicher verarbeitet. Unterstützer-Belohnungen (Münzen, Module und Enzyklopädie-Freischaltungen) werden deinem Grymwyrd-Konto gutgeschrieben, sobald der Kampagnen-Dienst live geht.',

  // LanguageSelect.tsx
  'books.language.label': 'Sprache',

  // PreviewModal.tsx
  'books.preview.title': 'Vorschau — {title}',
  'books.preview.pdfAria': 'Vorschau-PDF von {title}',
  'books.preview.cannotDisplay': 'Dein Beschwörer kann die Vorschau nicht eingebettet anzeigen.',
  'books.preview.openNewTab': 'Vorschau in einem neuen Tab öffnen',
  'books.preview.preparingHeading': 'Die Vorschau wird vorbereitet.',
  'books.preview.preparingBody':
    'Eine Leseprobe dieses Folianten wird vom Skriptorium eingeschrieben und erscheint in Kürze hier. Wirf in der Zwischenzeit einen Blick darauf, was darin verborgen liegt:',
  'books.preview.excerptLabel': 'Auszug — {title}',
  'books.preview.excerptFallback':
    'Jenseits dieser Schwelle liegen Seiten voller Grauen und Wunder. Erwirb den Folianten, um weiterzulesen.',
  'books.preview.noExcerpt': 'Für diesen Band wurde noch kein Auszug katalogisiert.',

  // RulesPage.tsx
  'books.rules.sectionSpells': 'Zauber',
  'books.rules.sectionMonsters': 'Monster',
  'books.rules.sectionMagicItems': 'Magische Gegenstände',
  'books.rules.sectionWeapons': 'Waffen',
  'books.rules.sectionArmor': 'Rüstung',
  'books.rules.sectionSkills': 'Fertigkeiten',
  'books.rules.entriesCount': '{entries} Einträge',
  'books.rules.readingLabel': '{label} wird gelesen…',
  'books.rules.noneCatalogued': 'Noch sind keine {label} in diesem System katalogisiert.',
  'books.rules.browseAll': 'Alle {label} in der Enzyklopädie durchstöbern →',
  'books.rules.seoTitle': 'Regeln & SRD',
  'books.rules.seoDescription':
    'Durchstöbere das System Reference Document — Zauber, Monster, Gegenstände und die Regeln, die das ewige Zwielicht binden. Jetzt das 5e-SRD, weitere Systeme folgen.',
  'books.rules.eyebrow': 'Der Codex',
  'books.rules.heading': 'Regeln & Systemreferenz',
  'books.rules.intro':
    'Der offene Spielinhalt, der Grymwyrd antreibt. Durchstöbere regelrelevante Einträge und tauche in die vollständige Enzyklopädie für Statblöcke und Überlieferung ein. Grymwyrd erscheint heute mit dem 5e-SRD — PF2e und weitere Systeme folgen.',
  'books.rules.loading': 'Der Codex wird zurate gezogen…',
  'books.rules.gameSystems': 'Spielsysteme',
  'books.rules.noSystems': 'Es sind noch keine Spielsysteme registriert.',
  'books.rules.openSrd': 'SRD öffnen',
  'books.rules.lockedComingSoon': 'Gesperrt — kommt bald',
  'books.rules.referenceContent': '{name} — Referenzinhalt',
  'books.rules.releasedUnder': 'Veröffentlicht unter {license}',
  'books.rules.licenseLink': 'Lizenz',

  // StretchGoals.tsx
  'books.stretch.goalProgressAria': 'Finanzierungsfortschritt von {title}',
  'books.stretch.unlockedAdded': 'Freigeschaltet — zur Enzyklopädie hinzugefügt',
  'books.stretch.percentFunded': '{pct}% finanziert',
  'books.stretch.autoPopulates': 'Füllt die Enzyklopädie automatisch',
  'books.stretch.raisedSoFar': 'Bisher gesammelt',
  'books.stretch.backers': 'Unterstützer',
  'books.stretch.overallAria': 'Gesamtfinanzierung der Kampagne',
  'books.stretch.heading': 'Stretch Goals',
}
